import Constant from "../Shared/Constant";
import PingTool from "../Shared/PingTool";
import { Global } from "../Shared/Global";
import AudioManager from "../Shared/AudioManager";
import AddressManager from "../Shared/AddressManager";

const { ccclass, property } = cc._decorator;
const i18n = require('LanguageData');


@ccclass
export default class Signal extends cc.Component {

    @property(cc.Node)
    content: cc.Node = null;
    @property(cc.Node)
    item: cc.Node = null;
    @property({ type: Function, visible: false })
    callback: Function = null;

    private interval = 1;
    private urls = [];

    async start() {
        this.urls = this.urls.concat(AddressManager.serverAddressArr);

        for (let i = 0; i < this.urls.length; i++) {
            let item = cc.instantiate(this.item);
            item.parent = this.content;
            item.active = true;
            let add = cc.sys.localStorage.getItem("ServerAddress");
            cc.log("====add:", add);
            cc.log("====curUrl:", this.urls[i]);
            if (add === this.urls[i]) {
                item.getChildByName("spCur").active = true;
            }
            cc.log("===this.url[%s]:", i, this.urls[i]);

            item.getChildByName("labName").getComponent(cc.Label).string = i18n.t('Signal.speed') + (i + 1);
            let btn = item.getChildByName("btnQiehuan");
            btn.getComponent(cc.Button).clickEvents[0].customEventData = i.toString();
            let url = this.urls[i];
            let signalNum: cc.Node = item.getChildByName("signalNum");
            signalNum.getComponent(cc.Label).string = i18n.t('Signal.in_test') + "...";
        }
        let items = this.content.children;
        for (let i = 0; i < this.urls.length; i++) {
            let signalNum = items[i].getChildByName("signalNum");
            let url = this.urls[i];
            await this.func(url, signalNum);
            this.schedule(this.func.bind(this, url, signalNum), this.interval)
        }
    }
    async func(url, signalNum) {
        let num = await PingTool.checkHttpLatency(url);
        //cc.log("====url:%s,num;%s", url, num);

        let param = PingTool.getColorByNum(num);
        let color1 = param[0] as cc.Color;
        if (cc.isValid(signalNum)) {
            signalNum && (signalNum.color = color1);
            signalNum && (signalNum.getComponent(cc.Label).string = num + "ms" + param[1]);
        }
    };



    update(dt: number): void {


    }

    onDestroy(): void {
        this.unscheduleAllCallbacks();
    }

    onBtnClose(event, param) {
        AudioManager.playSound("close");
        this.callback && this.callback()
        this.node.destroy();
    }
    onBtnClick(event, param) {
        AudioManager.playSound("button");
        let url = this.urls[parseInt(param)];
        AddressManager.setServerDomain(url);
        cc.director.emit(Global.UserEvent.CheckSignal, url);
        this.callback && this.callback()
        this.node.destroy();
    }

}
